import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-item-carousel__button p-item-carousel__button--prev" }
const _hoisted_2 = { class: "p-item-carousel__button__icon__wrap" }
const _hoisted_3 = { class: "p-item-carousel__button p-item-carousel__button--next" }
const _hoisted_4 = { class: "p-item-carousel__button__icon__wrap" }
const _hoisted_5 = { class: "p-item-carousel__sp_lists" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconArrowLeft = _resolveComponent("IconArrowLeft")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_IconArrowRight = _resolveComponent("IconArrowRight")!
  const _component_ItemListPanel = _resolveComponent("ItemListPanel")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_AppSwiper = _resolveComponent("AppSwiper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-item-carousel", [`p-item-carousel--${_ctx.carouselName}`]])
  }, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_IconBase, {
            class: "p-item-carousel__button__icon",
            "view-box": "0 0 24 24",
            width: "24",
            height: "24"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconArrowLeft)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_IconBase, {
            class: "p-item-carousel__button__icon",
            "view-box": "0 0 24 24",
            width: "24",
            height: "24"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconArrowRight)
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_AppSwiper, {
        class: "swiper",
        options: _ctx.swiperOption
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (item, key) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, { key: key }, {
              default: _withCtx(() => [
                _createVNode(_component_ItemListPanel, {
                  id: item.id,
                  "img-path": item.image,
                  name: item.name,
                  point: item.point,
                  "discount-rate": item.discount_rate,
                  "is-favorite": item.is_favorite,
                  color: item.colorCode,
                  status: item.status,
                  stock: item.stock,
                  "stock-control": item.is_quantity_control
                }, null, 8, ["id", "img-path", "name", "point", "discount-rate", "is-favorite", "color", "status", "stock", "stock-control"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["options"])
    ], 512), [
      [_vShow, !_ctx.isSp]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemList, (item, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${key}_sp`,
          class: "p-item-carousel__panel"
        }, [
          (key < 4)
            ? (_openBlock(), _createBlock(_component_ItemListPanel, {
                key: 0,
                id: `${item.id}_sp`,
                "img-path": item.image,
                name: item.name,
                point: item.point,
                "discount-rate": item.discount_rate,
                "is-favorite": item.is_favorite,
                status: item.status,
                color: item.colorCode,
                stock: item.stock,
                "stock-control": item.is_quantity_control
              }, null, 8, ["id", "img-path", "name", "point", "discount-rate", "is-favorite", "status", "color", "stock", "stock-control"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ], 512), [
      [_vShow, _ctx.isSp]
    ])
  ], 2))
}